import axios from "axios"

const controller = "/ordenCompra"

const OrdenCompraService = {
    async obtener(request) {
        const { data } = await axios.post(`${controller}/obtener`, request)
        return data
    },
    async buscar(request) {
        const { data } = await axios.post(`${controller}/buscar`, request)
        return data
    },
    async obtenerDetallexTransferencia(request) {
        const { data } = await axios.post(`${controller}/obtenerDetallexTransferencia`, request)
        return data
    },
    async generarReporte2(request) {
        const { data } = await axios.post(`${controller}/generarReporte2`, request)
        return data
    }
}

export default OrdenCompraService